<template>
  <div
    v-if="widget"
    class="hbt"
  >
    <div class="hbt-day-grid">
      <div class="hbt-day-date">
        <div class="hbt-kicker mb-25">
          {{ widget.param.title || 'Сегодня' }} / {{ widget.param.subtitle || 'today' }}
        </div>
        <div class="hbt-h1">
          {{ dateRu }}
        </div>
        <div class="hbt-mut">
          {{ dateEn }}
        </div>
      </div>
      <div class="hbt-day-progress">
        <div class="d-flex align-items-baseline justify-content-between">
          <span class="hbt-kicker-mut">Выполнение плана</span>
          <span
            class="hbt-num"
            style="font-size: 30px;"
          >{{ pct }}%</span>
        </div>
        <div class="hbt-bar mt-50">
          <div
            class="hbt-bar-fill"
            :style="{ width: `${pct}%` }"
          />
        </div>
        <div class="hbt-mut mt-25">
          {{ doneText }}
        </div>
      </div>
      <div
        v-if="showStreak"
        class="hbt-day-streak"
      >
        <div class="hbt-kicker-mut mb-25">
          Серия / streak
        </div>
        <div class="d-flex align-items-baseline">
          <span
            class="hbt-num"
            style="font-size: 34px;"
          >{{ streak }}</span>
          <span class="hbt-mut ml-50">дней подряд</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  HBT_REFRESH, hbtLoadHabits, hbtLoadLogs, hbtDayCompletion, hbtStreak, hbtDayKey,
  hbtFmtDateRu, hbtFmtDateEn,
} from '@/cubus/components/dashboard/habits/habitsCore'

export default {
  name: 'CbsWidgetHabitDay',
  props: {
    widget: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      habits: [],
      logs: [],
      streak: 0,
    }
  },
  computed: {
    today() {
      return hbtDayCompletion(this.habits, this.logs, hbtDayKey(new Date()))
    },
    pct() {
      return this.today.pct
    },
    doneText() {
      const t = this.today
      const done = Math.round(t.done * 10) / 10
      return `${done} из ${t.units} привычек закрыто`
    },
    dateRu() {
      return hbtFmtDateRu(new Date())
    },
    dateEn() {
      return hbtFmtDateEn(new Date())
    },
    showStreak() {
      return this.widget.param.showstreak !== false
    },
  },
  created() {
    this.load()
    this.$root.$on(HBT_REFRESH, this.load)
  },
  beforeDestroy() {
    this.$root.$off(HBT_REFRESH, this.load)
  },
  methods: {
    async load() {
      const days = Number(this.widget.param.streakdays) || 60
      this.habits = await hbtLoadHabits(this, this.widget.param)
      this.logs = await hbtLoadLogs(this, this.widget.param, days)
      this.streak = hbtStreak(this.habits, this.logs, days)
    },
  },
}
</script>

<style src="./habits/habits.css"></style>
<style scoped>
.hbt-day-grid {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 40px;
}
.hbt-day-date {
  min-width: 200px;
}
.hbt-day-progress {
  flex: 1;
  min-width: 240px;
}
.hbt-day-streak {
  min-width: 130px;
}
</style>
